'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp; /**
                                          * Created by lyj on 2016/5/16.
                                          */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRedux = require('react-redux');

var _register = require('redux/modules/register');

var registerActions = _interopRequireWildcard(_register);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _reactRouterRedux = require('react-router-redux');

var _background = require('redux/modules/background');

var _reduxAsyncConnect = require('redux-async-connect');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Register = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var dispatch = _ref.store.dispatch;

    var promises = [];
    promises.push(dispatch((0, _background.changeHeaderText)('注册')));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    submitted: state.register.submitted,
    registerResult: state.register.registerResult
  };
}, (0, _extends3.default)({
  routerPush: _reactRouterRedux.push
}, registerActions, authActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Register, _Component);

  function Register() {
    (0, _classCallCheck3.default)(this, Register);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Register).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(Register, [{
    key: 'onSubmit',
    value: function onSubmit(data) {
      var infoSubmit = this.props.infoSubmit;

      if (infoSubmit) {
        infoSubmit(data);
      }
    }
  }, {
    key: 'onVerifyCodeClick',
    value: function onVerifyCodeClick(mobile) {
      var getCode = this.props.getCode;

      if (getCode) {
        getCode(mobile, '1');
      }
    }
  }, {
    key: 'onCloseRegisterModal',
    value: function onCloseRegisterModal() {
      var routerPush = this.props.routerPush;

      routerPush('/personalcenter/personalinfo');
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ChangeInfo.scss');
      var _props = this.props;
      var submitted = _props.submitted;
      var registerResult = _props.registerResult;

      var content = _react2.default.createElement(
        'div',
        { className: styles.register_mes },
        _react2.default.createElement(
          'div',
          { className: styles.register_mes_inp },
          _react2.default.createElement(
            'p',
            { className: styles.mes_inp_tit },
            '注册'
          ),
          _react2.default.createElement('div', { className: styles.register_line, style: { marginLeft: '0px' } }),
          _react2.default.createElement(
            'div',
            { className: styles.mes_input_photo },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/lonlogo.png', alt: '' })
          ),
          _react2.default.createElement(_components.RegisterForm, { getVerifyCode: this.onVerifyCodeClick.bind(this), onSubmit: this.onSubmit.bind(this) }),
          submitted && registerResult.isValid === false ? _react2.default.createElement(_components.ErrorLabel, { error: registerResult.message }) : ''
        ),
        _react2.default.createElement('img', { className: styles.register_bg, src: 'http://tupian.goeasy.cn:9999/yipinwang/register/register-bg1.png',
          alt: '' })
      );
      if (submitted && registerResult.isValid === true) {
        content =
        /*  <div className={styles.register_mes}>
         <div className={styles.submittedSucess}>
         <img className={styles.submittedSucesLogo} src="http://tupian.goeasy.cn:9999/yipinwang/logo.png" alt=""/>
         <p className={styles.submittedSucessTit}>艺品网提醒您</p>
         <p className={styles.submittedSucessContent}>注册成功</p>
         </div>
         </div>*/
        _react2.default.createElement(_components.AttentionSuccessModal, { isOpened: submitted && registerResult.isValid === true
          // width="400"
          , loginStyle: { background: 'url("http://tupian.goeasy.cn:9999/yipinwang/wbg/zhuce_sucess_1.png") no-repeat' },
          closeModalFunc: this.onCloseRegisterModal.bind(this),
          text: '注册成功' });
      }
      return _react2.default.createElement(
        'div',
        { className: 'Center_gr', style: { marginTop: '0px', marginBottom: '45px' } },
        content
      );
    }
  }]);
  return Register;
}(_react.Component), _class2.propTypes = {
  dispatch: _react.PropTypes.func,
  registerResult: _react.PropTypes.object,
  submitted: _react.PropTypes.bool,
  infoSubmit: _react.PropTypes.func,
  getCode: _react.PropTypes.func,
  routerPush: _react.PropTypes.func
}, _temp)) || _class) || _class);
exports.default = Register;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ChangeInfo/Register.js
 ** module id = 1448
 ** module chunks = 0
 **/